export const STATUS_NOT_FOUND = 404;
export const STATUS_INTERNAL_SERVER_ERROR = 500;
export const STATUS_CONFLICT = 409;
export const ERROR_PAGES = [
    STATUS_NOT_FOUND,
    STATUS_INTERNAL_SERVER_ERROR,
];
export const isErrorPage = (pathname) => ERROR_PAGES.some((page) => page === Number(pathname));
//# sourceMappingURL=errors.js.map